export class MessengerService {
    static $inject = ['ConfigurationsService', 'ProfileCommandProcessor', 'MessagingHubService', 'MESSAGINGHUBDOMAIN'];
    constructor(ConfigurationsService, ProfileCommandProcessor, MessagingHubService, MESSAGINGHUBDOMAIN) {
        this.ConfigurationsService = ConfigurationsService;
        this.ProfileCommandProcessor = ProfileCommandProcessor;
        this.MessagingHubService = MessagingHubService;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
    }
    setConfiguration(configuration, useConfigurationsApplication = false) {
        return this.ConfigurationsService.set(`postmaster@messenger.gw.${this.MESSAGINGHUBDOMAIN}`, configuration, undefined, useConfigurationsApplication);
    }
    validateApplicationInfo(applicationInfo) {
        return this.MessagingHubService.sendCommand({
            method: 'set',
            to: `postmaster@messenger.gw.${this.MESSAGINGHUBDOMAIN}`,
            uri: '/validate-app',
            type: 'application/vnd.iris.facebook.application+json',
            resource: { ...applicationInfo },
        });
    }
    //WhitelistedDomains
    savewhiteListedDomains(application, whiteListedDomains) {
        return this.ProfileCommandProcessor.sendProfileCommand(application, 'set', 'whitelisted-domains', 'application/vnd.lime.collection+json', {
            itemType: 'application/vnd.lime.web-link+json',
            items: whiteListedDomains,
        });
    }
    getwhiteListedDomains(application) {
        return this.ProfileCommandProcessor.sendProfileCommand(application, 'get', 'whitelisted-domains');
    }
    deletewhiteListedDomains(application) {
        return this.ProfileCommandProcessor.sendProfileCommand(application, 'delete', 'whitelisted-domains');
    }
}
MessengerService.$inject = ['ConfigurationsService', 'ProfileCommandProcessor', 'MessagingHubService', 'MESSAGINGHUBDOMAIN'];
